export enum SelectedBannerTypeEnumerator {
  ELECTIVE = 1,
  TRAIL = 2,
}

export const selectedBannerTypeEnumeratorMap: Map<SelectedBannerTypeEnumerator, string> = new Map<SelectedBannerTypeEnumerator, string>([
  [SelectedBannerTypeEnumerator.ELECTIVE, 'Eletivas'],
  [SelectedBannerTypeEnumerator.TRAIL, 'Tecer'],
]);
